import { ArrowLeft, Utensils } from "lucide-react";
import { Link } from "react-router-dom";

export default function MenuOverviewEmptyState() {
  return (
    <section className="mx-auto mt-10 flex max-w-xl flex-col items-center rounded-2xl border border-gray-200 bg-white px-5 py-10 text-center" aria-labelledby="empty-menu-title">
      <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-primary_1 text-primary">
        <Utensils size={24} aria-hidden="true" />
      </span>
      <h2 id="empty-menu-title" className="mt-4 text-lg font-extrabold text-accent">هنوز منویی نساخته‌اید</h2>
      <p className="mt-2 max-w-md text-sm leading-7 text-gray-500">
        برای شروع، دسته‌بندی‌ها و آیتم‌های منوی رستوران را اضافه کنید. پس از ذخیره، لینک و QR منو در همین صفحه در دسترس خواهد بود.
      </p>
      <Link to="/dashboard/edit-menu" className="mt-5 inline-flex min-h-11 items-center gap-2 rounded-xl bg-primary px-5 py-2.5 text-sm font-bold text-white transition-colors hover:bg-[#e8731f] focus:outline-none focus:ring-4 focus:ring-primary/20">
        ساخت منو
        <ArrowLeft size={17} aria-hidden="true" />
      </Link>
    </section>
  );
}
